import React, { useState } from 'react';
import InventoryDashboard from './InventoryDashboard';
import StockItems from './StockItems';
import Categories from './Categories';
import Suppliers from './Suppliers';
import PurchaseOrders from './PurchaseOrders';
import StockInward from './StockInward';
import Recipes from './Recipes';
import Adjustments from './Adjustments';
import Wastage from './Wastage';
import StockAudit from './StockAudit';
import InventoryReports from './InventoryReports';

const TABS = [
  { id: 'dashboard',   label: 'Dashboard' },
  { id: 'items',       label: 'Stock Items' },
  { id: 'categories',  label: 'Categories' },
  { id: 'suppliers',   label: 'Suppliers' },
  { id: 'pos',         label: 'Purchase Orders' },
  { id: 'inward',      label: 'Stock Inward' },
  { id: 'recipes',     label: 'Recipes' },
  { id: 'adjustments', label: 'Adjustments' },
  { id: 'wastage',     label: 'Wastage' },
  { id: 'audit',       label: 'Stock Audit' },
  { id: 'reports',     label: 'Reports' },
];

const STORAGE_KEY = 'inv_active_tab';
const validTabIds = TABS.map(t => t.id);

const InventoryApp = ({ restaurant }) => {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  const [activeTab, setActiveTab] = useState(validTabIds.includes(stored) ? stored : 'dashboard');
  const [navState, setNavState]   = useState(null);
  const [inwardKey, setInwardKey] = useState('manual');

  const navigate = (tab, state = null) => {
    if (tab === 'inward' && state?.po) {
      setInwardKey(state.po.id);
    }
    setNavState(state);
    setActiveTab(tab);
    sessionStorage.setItem(STORAGE_KEY, tab);
  };

  const renderTab = () => {
    switch (activeTab) {
      case 'dashboard':    return <InventoryDashboard restaurant={restaurant} onNavigate={navigate} />;
      case 'items':        return <StockItems restaurant={restaurant} />;
      case 'categories':   return <Categories restaurant={restaurant} />;
      case 'suppliers':    return <Suppliers restaurant={restaurant} />;
      case 'pos':          return <PurchaseOrders restaurant={restaurant} onNavigate={navigate} />;
      case 'inward':       return <StockInward key={inwardKey} restaurant={restaurant} initialPO={navState?.po || null} onSaved={() => { setNavState(null); setInwardKey('manual'); }} />;
      case 'recipes':      return <Recipes restaurant={restaurant} />;
      case 'adjustments':  return <Adjustments restaurant={restaurant} />;
      case 'wastage':      return <Wastage restaurant={restaurant} />;
      case 'audit':        return <StockAudit restaurant={restaurant} />;
      case 'reports':      return <InventoryReports restaurant={restaurant} />;
      default:             return <InventoryDashboard restaurant={restaurant} />;
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      {/* Sub-navigation bar */}
      <div style={{
        background: 'white',
        borderBottom: '1px solid #f0f0f0',
        padding: '0 20px',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
      }}>
        <div style={{ display: 'inline-flex', gap: '2px', padding: '8px 0' }}>
          {TABS.map(t => (
            <button
              key={t.id}
              onClick={() => { setActiveTab(t.id); setNavState(null); sessionStorage.setItem(STORAGE_KEY, t.id); }}
              style={{
                padding: '7px 16px',
                borderRadius: '8px',
                border: 'none',
                cursor: 'pointer',
                fontWeight: activeTab === t.id ? '700' : '500',
                fontSize: '0.85rem',
                background: activeTab === t.id
                  ? 'linear-gradient(135deg, #FF4444, #FF6B00)'
                  : 'transparent',
                color: activeTab === t.id ? 'white' : '#555',
                transition: 'all 0.15s',
                whiteSpace: 'nowrap',
              }}
              onMouseOver={e => { if (activeTab !== t.id) e.currentTarget.style.background = '#f3f4f6'; }}
              onMouseOut={e => { if (activeTab !== t.id) e.currentTarget.style.background = 'transparent'; }}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      {renderTab()}
    </div>
  );
};

export default InventoryApp;
